import { render, staticRenderFns } from "./CustomerBubble.vue?vue&type=template&id=9f076404&"
import script from "./CustomerBubble.vue?vue&type=script&lang=js&"
export * from "./CustomerBubble.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports